/*
 * Quantity beside Add to cart.
 *
 * Dawn renders the two as separate blocks: the quantity selector is a child
 * of the info column, while the buttons live inside the product <form>. That
 * makes them non-siblings, so no amount of CSS can put them on one line —
 * the quantity has to actually move into the form.
 *
 * Moving it rather than rewriting the section keeps every Dawn behaviour
 * attached to it (the variant script updates its rules, the cart count, the
 * loading spinner) because it is the same element, just relocated.
 */
(function () {
  function pair(scope) {
    var root = scope || document;
    root.querySelectorAll('.product-form__buttons').forEach(function (buttons) {
      var form = buttons.closest('form') || buttons.parentElement;
      var info = buttons.closest('.product__info-container');
      if (!info) return;

      var qty = info.querySelector('.product-form__quantity');
      if (!qty || qty.dataset.nvPaired) return;

      // A wrapper the CSS can lay out, inserted where the buttons already sit
      // so the form's own submit handling is untouched.
      var row = document.createElement('div');
      row.className = 'nv-qty-row';
      buttons.parentNode.insertBefore(row, buttons);
      row.appendChild(qty);
      row.appendChild(buttons);

      qty.dataset.nvPaired = '1';
    });
  }

  function init() { pair(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The variant picker re-renders this part of the page on every change.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:changed', init);
})();
